import React from 'react';
import { BrainCircuit } from 'lucide-react';
export function SectionDivider() {
  return <div className="w-full flex items-center justify-center py-12 opacity-30" data-id="element-189">
      <div className="h-px bg-cyan-signal/30 w-16 md:w-32" data-id="element-190" />
      <BrainCircuit className="w-6 h-6 text-cyan-signal mx-4" data-id="element-191" />
      <div className="h-px bg-cyan-signal/30 w-16 md:w-32" data-id="element-192" />
    </div>;
}